import React, { useMemo } from 'react';
import './App.css';
import { Container } from 'react-bootstrap';
import Users from './pages/main/Users';
import Dialogs from './components/Dialogs';
import Applications from './pages/main/Applications';
import Admin from './pages/main/Admin';
import PageRouter from './pages/PageRouter';
import MobileRestriction from './components/MobileRestriction';
// svgs
import { ReactComponent as AppsIcon } from './svgs/apps.svg'
import { ReactComponent as ManageIcon } from './svgs/manage.svg'
import { ReactComponent as UserIcon } from './svgs/user.svg'
import { ReactComponent as UsersIcon } from './svgs/users.svg'
import { ReactComponent as Subscribe } from './svgs/subscriptions.svg'
import { ReactComponent as BankIcon } from './svgs/bank.svg'
import SubsPage from './pages/main/Subs';
import ProfilePage from './pages/main/Profile';
import CompanyProfilePage from './pages/main/CompanyProfile';
import { useAuth } from './api/auth/store';
import { ADMIN_ROLE, OWNER_ROLE } from './constants';

function App() {
  const { hasRole } = useAuth()
  const isPrivileged = hasRole(ADMIN_ROLE) || hasRole(OWNER_ROLE)
  //console.log(isPrivileged)
  const pages = useMemo(() => [
    {
      id: 'profile',
      label: 'Profile',
      path: '/manage/me',
      element: <ProfilePage />,
      icon: UserIcon
    },
    {
      id: 'bank',
      label: 'Company',
      path: isPrivileged ? '/manage/company' : '/manage/company/profile',
      element: isPrivileged ? <CompanyProfilePage /> : <CompanyProfilePage subpage="profile" />,
      icon: BankIcon,
      subs: isPrivileged ? [
        {
          id: "company-profile",
          label: "Profile",
          icon: "profile",
          path: '/manage/company/profile',
          element: <CompanyProfilePage subpage="profile" />
        },
        {
          id: "company-devices",
          label: "Device Approval",
          icon: "devices",
          path: '/manage/company/devices',
          element: <CompanyProfilePage subpage="devices" />
        },
        {
          id: "company-ip-whitelist",
          label: "IP Whitelist",
          icon: "whitelist",
          path: '/manage/company/ip-whitelist',
          element: <CompanyProfilePage subpage="ip-whitelist" />
        }
      ] : null
    },
    {
      id: 'users',
      label: 'Users',
      path: '/manage/users',
      element: <Users />,
      icon: UsersIcon
    },
    {
      id: 'subs',
      label: 'Subscriptions',
      path: '/manage/subs',
      element: <SubsPage />,
      icon: Subscribe
    },
    {
      id: "dev",
      label: "Developer",
      path: '/manage/dev',
      element: <Applications />,
      icon: AppsIcon,
    },
    {
      id: "admin",
      label: "Admin",
      path: '/manage/admin',
      element: <Admin />,
      icon: ManageIcon,
      subs: [
        {
          id: "admin-companies",
          label: "Companies",
          icon: "companies",
          path: '/manage/admin/companies',
          element: <Admin subpage="companies" />
        },
        {
          id: "admin-ip-whitelist",
          label: "IP Whitelist",
          icon: "whitelist",
          path: '/manage/admin/ip-whitelist',
          element: <Admin subpage="ip-whitelist" />
        },
        {
          id: "admin-ip-banned",
          label: "Banned IPs",
          icon: "banned",
          path: '/manage/admin/ip-banned',
          element: <Admin subpage="ip-banned" />
        }
      ]
    }
  ], [isPrivileged]);

  return (
    <Container className="main-container">
      <MobileRestriction />
      <Dialogs />
      <PageRouter pages={pages} />
    </Container>
  );
}

export default App;
